import React from "react";
import { Button } from "@mui/material";
import { FilterChip } from "./components/filterChip/filterChip.index";
import { FilterShowcaseProps } from "./filterShowcase.models";
import { renderFilterTitle } from "./filterShowcase.utils";
import styles from "./filterShowcase.module.css";

export const FilterShowcase = <TKey extends string = string>({
    chips,
    onRemove,
    onClearAll,
}: FilterShowcaseProps<TKey>) => (
    <div className={styles.filterShowcaseCtn}>
        {chips.map((chip) => (
            <FilterChip key={chip.key} onRemove={() => onRemove(chip.key)}>
                {renderFilterTitle(chip.titles, chip.label)}
            </FilterChip>
        ))}
        {chips.length > 1 && (
            <Button variant="outlined" className={styles.clearAllBtn} onClick={onClearAll}>
                Clear All
            </Button>
        )}
    </div>
);